(function () {
  'use strict';
  if (window.msProductReviewsBound) return;
  window.msProductReviewsBound = true;

  const panels = new Map();
  let libraryReady = false;
  let readyTimer = 0;
  let retryTimer = 0;
  let retryCount = 0;
  let reviewAnchorRequested = false;

  function syncReviews(acceptEmpty) {
    document.querySelectorAll('[data-ms-native-rating-badge]').forEach(function (badge) {
      const productId = badge.dataset.productId;
      const source = Array.from(document.querySelectorAll('.product__stamped-badge-source .stamped-product-reviews-badge'))
        .find(function (node) { return node.getAttribute('data-id') === productId; });
      const caption = source && source.querySelector('.stamped-badge-caption');
      let countRaw = caption ? (caption.getAttribute('data-reviews') || '').trim() : '';
      let averageRaw = caption ? (caption.getAttribute('data-rating') || '').trim().replace(',', '.') : '';
      if (!/^\d+$/.test(countRaw) || (Number(countRaw) === 0 && acceptEmpty !== true) || (Number(countRaw) > 0 && (!/^\d+(\.\d+)?$/.test(averageRaw) || Number(averageRaw) < 1 || Number(averageRaw) > 5))) {
        countRaw = badge.dataset.msRatingCount || '';
        averageRaw = badge.dataset.msRatingAverage || '';
      }
      const count = /^\d+$/.test(countRaw) ? Number(countRaw) : NaN;
      const average = /^\d+(\.\d+)?$/.test(averageRaw) ? Number(averageRaw) : NaN;
      const valid = Number.isSafeInteger(count) && count > 0 && average >= 1 && average <= 5;
      const empty = count === 0 && acceptEmpty === true;
      if (!valid && !empty) return;
      const text = badge.querySelector('.ms-native-rating-badge__text');
      const stars = badge.querySelector('.ms-native-rating-badge__stars');
      if (!text || !stars) return;

      if (valid) {
        const displayAverage = average.toFixed(1).replace('.', ',');
        text.textContent = displayAverage + ' · ' + count + (count === 1 ? ' omtale' : ' omtaler');
        badge.setAttribute('aria-label', displayAverage + ' av 5 stjerner basert på ' + count + (count === 1 ? ' omtale' : ' omtaler'));
        badge.dataset.msRatingCount = String(count);
        badge.dataset.msRatingAverage = String(average);
        stars.style.setProperty('--ms-rating-fill', (average * 20) + '%');
        stars.hidden = false;
      } else {
        text.textContent = 'Se kundeomtaler';
        badge.setAttribute('aria-label', 'Se kundeomtaler');
        delete badge.dataset.msRatingCount;
        delete badge.dataset.msRatingAverage;
        stars.hidden = true;
      }

      const schemaNode = Array.from(document.querySelectorAll('script[data-ms-product-schema]'))
        .find(function (node) { return node.dataset.msProductSchema === productId; });
      if (!schemaNode) return;
      try {
        const schema = JSON.parse(schemaNode.textContent);
        if (schema['@type'] !== 'Product') return;
        if (valid) {
          schema.aggregateRating = {
            '@type': 'AggregateRating',
            ratingValue: average,
            ratingCount: count,
            bestRating: 5,
            worstRating: 1
          };
        } else {
          delete schema.aggregateRating;
        }
        schemaNode.textContent = JSON.stringify(schema);
      } catch (error) {}
    });
  }

  function showStatus(panel, failed) {
    const status = panel.querySelector('[data-ms-reviews-status]');
    if (!status) return;
    status.hidden = false;
    const text = status.querySelector('[data-ms-reviews-status-text]');
    const retry = status.querySelector('[data-ms-reviews-retry]');
    if (text) text.textContent = failed ? status.dataset.unavailable : status.dataset.loading;
    if (retry) retry.hidden = !failed;
  }

  function unavailable(panel) {
    const state = panels.get(panel);
    if (!state || panel.dataset.msStampedLazy === 'ready') return;
    panel.dataset.msStampedLazy = 'unavailable';
    panel.removeAttribute('aria-busy');
    showStatus(panel, true);
  }

  function loading(panel) {
    const state = panels.get(panel);
    panel.dataset.msStampedLazy = 'loading';
    panel.setAttribute('aria-busy', 'true');
    showStatus(panel, false);
    if (state.timeout) window.clearTimeout(state.timeout);
    state.timeout = window.setTimeout(function () { unavailable(panel); }, 15000);
  }

  function activateRequested() {
    retryTimer = 0;
    let mounted = false;
    panels.forEach(function (state, panel) {
      if (!panel.isConnected) {
        if (state.observer) state.observer.disconnect();
        if (state.timeout) window.clearTimeout(state.timeout);
        panels.delete(panel);
        return;
      }
      if (!state.requested || state.mounted || !libraryReady || !window.StampedFn || typeof window.StampedFn.reloadUGC !== 'function') return;
      const template = panel.querySelector('template[data-ms-stamped-template]');
      if (!template || !template.content) return;
      state.mounted = true;
      loading(panel);
      panel.appendChild(template.content.cloneNode(true));
      template.remove();
      if (state.observer) state.observer.disconnect();
      mounted = true;
    });
    if (mounted) {
      try {
        window.StampedFn.reloadUGC();
        panels.forEach(function (state) { if (state.mounted) state.initialized = true; });
      } catch (error) {
        panels.forEach(function (state, panel) {
          if (state.mounted) unavailable(panel);
        });
      }
    }
    const waiting = Array.from(panels.values()).some(function (state) { return state.requested && !state.mounted; });
    if (waiting && retryCount < 60) {
      retryCount += 1;
      retryTimer = window.setTimeout(activateRequested, 250);
    }
    if (mounted && reviewAnchorRequested) {
      reviewAnchorRequested = false;
      const panel = Array.from(panels.keys()).find(function (node) { return node.isConnected; });
      const header = document.querySelector('[data-sticky-header]');
      if (panel) window.scrollTo({ top: Math.max(0, panel.getBoundingClientRect().top + window.scrollY - (header ? Math.min(header.getBoundingClientRect().height, 180) : 0) - 16), behavior: 'auto' });
    }
  }

  function requestReviews(panel, retry) {
    const state = panels.get(panel);
    if (!state) return;
    if (state.mounted) {
      const method = state.initialized ? 'loadWidget' : 'reloadUGC';
      if (retry && window.StampedFn && typeof window.StampedFn[method] === 'function') {
        loading(panel);
        try { window.StampedFn[method](); state.initialized = true; } catch (error) { unavailable(panel); }
      }
      return;
    }
    state.requested = true;
    loading(panel);
    if (!retryTimer) {
      retryCount = 0;
      activateRequested();
    }
  }

  function onLibraryReady() {
    if (readyTimer) return;
    readyTimer = window.setTimeout(function () {
      readyTimer = 0;
      libraryReady = true;
      if (retryTimer) window.clearTimeout(retryTimer);
      activateRequested();
    }, 0);
  }

  function checkHash() {
    const params = new URLSearchParams(window.location.search);
    if (!/^#(?:stamped-main-widget|stamped_r_id|write_review|write_question)(?:[=&-]|$)/.test(window.location.hash) && !params.has('stamped_r_id') && !params.has('write_review') && !params.has('write_question')) return;
    if (window.location.hash === '#stamped-main-widget') {
      reviewAnchorRequested = Array.from(panels.values()).some(function (state) { return !state.mounted; });
    }
    panels.forEach(function (state, panel) { requestReviews(panel); });
  }

  function bindPanels() {
    document.querySelectorAll('[data-ms-stamped-lazy]').forEach(function (panel) {
      if (panels.has(panel)) return;
      const state = { requested: false, mounted: false, initialized: false, observer: null, timeout: 0 };
      panels.set(panel, state);
      const retry = panel.querySelector('[data-ms-reviews-retry]');
      if (retry) retry.addEventListener('click', function () { requestReviews(panel, true); });
      if ('IntersectionObserver' in window) {
        state.observer = new window.IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) requestReviews(panel);
        }, { rootMargin: Math.max(window.innerHeight || 0, 400) + 'px 0px' });
        state.observer.observe(panel);
      } else {
        requestReviews(panel);
      }
    });
    syncReviews();
    checkHash();
  }

  document.addEventListener('stamped:init:starting', onLibraryReady);
  document.addEventListener('stamped:badges:loaded', function () { syncReviews(true); onLibraryReady(); });
  document.addEventListener('stamped:reviews:loaded', function () {
    syncReviews();
    panels.forEach(function (state, panel) {
      const widget = panel.querySelector('#stamped-main-widget');
      if (state.mounted && widget && widget.childElementCount) {
        panel.dataset.msStampedLazy = 'ready';
        panel.removeAttribute('aria-busy');
        if (state.timeout) window.clearTimeout(state.timeout);
        const status = panel.querySelector('[data-ms-reviews-status]');
        if (status) status.hidden = true;
      }
    });
    onLibraryReady();
  });
  document.addEventListener('shopify:section:load', bindPanels);
  window.addEventListener('hashchange', checkHash);
  window.addEventListener('click', function (event) {
    const target = event.target;
    const badge = target && target.closest && target.closest('.ms-native-rating-badge, .stamped-product-reviews-badge, .stamped-main-badge, .stamped-badge');
    if (!badge || badge.closest('#stamped-main-widget')) return;
    panels.forEach(function (state, panel) { requestReviews(panel); });
  }, true);
  bindPanels();
}());
